// Pure resolution of SEO props + route config + location into final values.

import { ASSETS } from '@airhead-games/shared/configs';
import { getSEOConfig } from '@airhead-games/shared/utilities';
import type { ResolvedSEO, SEOProps } from './types';

export const SITE_URL = 'https://www.airheadgames.com';

const DEFAULT_TITLE = 'Airhead Games | Party Games for Streamers';
const DEFAULT_DESCRIPTION =
  'Party games for streamers, shaped by the people who play them. Fresh every session and frictionless to join.';

interface ResolveInput {
  props: SEOProps;
  pathname: string;
  normalizedPath: string;
}

export const resolveSEO = ({
  props,
  pathname,
  normalizedPath,
}: ResolveInput): ResolvedSEO => {
  const { title, description, image, url, autoDetect = true } = props;

  const routeConfig =
    autoDetect && !title && !description ? getSEOConfig(normalizedPath) : null;

  const isHomePage = pathname === '/';

  const finalTitle = title
    ? `${title} | Airhead Games`
    : routeConfig
      ? isHomePage && routeConfig.title === 'Airhead Games'
        ? DEFAULT_TITLE
        : `${routeConfig.title} | Airhead Games`
      : DEFAULT_TITLE;

  const finalDescription =
    description || routeConfig?.description || DEFAULT_DESCRIPTION;

  const finalImage = image || routeConfig?.image || ASSETS.ogImage;

  const finalUrl = url ? `${SITE_URL}${url}` : `${SITE_URL}${pathname}`;

  return {
    title: finalTitle,
    description: finalDescription,
    image: finalImage,
    url: finalUrl,
    isHomePage,
  };
};
